import Sentry from '@saucelabs/sl-util-sentry';
import debounce from 'lodash.debounce';

import { euAndEeaCountries, isoCodes, states } from './countries';

export const getCountries = () => (
  Object.keys(isoCodes).map((element) => ({ text: element, value: isoCodes[element] }))
);

// EEA -> European Economic Area
export const getEUAndEEACountries = () => (
  Object.keys(isoCodes)
    .filter((key) => euAndEeaCountries.some((eeaIso) => eeaIso === isoCodes[key]))
    .map((element) => ({ text: element, value: isoCodes[element] }))
);

export const getROWCountries = () => (
  Object.keys(isoCodes)
    .filter((key) => !euAndEeaCountries.some((eeaIso) => eeaIso === isoCodes[key]))
    .map((element) => ({ text: element, value: isoCodes[element] }))
);

export const getAvailableCountries = (currentCountry) => {
  const allCountries = getCountries();
  // check for arg existence and check if provided arg is actually country code
  if (!currentCountry || !allCountries.some((country) => country.value === currentCountry)) {
    return allCountries;
  }
  const isEEACountry = euAndEeaCountries.includes(currentCountry);
  return isEEACountry ? getEUAndEEACountries() : getROWCountries();
};

export const getCountryByCode = (countryCode) => (
  getCountries().find((country) => country.value === countryCode)?.text
);

export const getCountryCode = debounce((fullCountryName) => {
  if (!fullCountryName) {
    return null;
  }
  const countryCode = isoCodes[fullCountryName];
  if (!countryCode) {
    // debounce is needed for this, as this function is often called in series
    Sentry.captureMessage(`Country code not found for country name "${fullCountryName}"!`);
  }
  return countryCode;
}, 1000, { leading: true, trailing: false });

const filterByCountry = (countryCode) => {
  const country = getCountryByCode(countryCode);
  const statesNames = country ? states[country] : [];
  if (Array.isArray(statesNames)) {
    // Non USA states just have a description
    return statesNames.map((stateName) => ({
      text: stateName,
      value: stateName,
    }));
  }
  // USA states have a code => description structure
  return Object.keys(statesNames).map((code) => ({ text: statesNames[code], value: code }));
};

export const getStateName = (countryCode, stateCode) => {
  const country = getCountryByCode(countryCode);
  const statesNames = country ? states[country] : [];
  if (Array.isArray(statesNames)) {
    // Non USA states just have a description
    return stateCode;
  }
  // USA states have a code => description structure
  return statesNames[stateCode];
};

export const getStateByCountryCode = (countryCode) => (
  countryCode ? filterByCountry(countryCode) : []
);

export default {
  getCountries,
  getStateForCountry: getStateByCountryCode,
};
